<template>
  <b-container>
    <b-embed
      v-if="accessTransaction"
      :src="dashboardUrl"
      frameborder="0"
      class="showBI"
      allowtransparency
    />
    <noPermission v-else />
  </b-container>
</template>

<script>
import {
  BContainer,
  BEmbed,
} from 'bootstrap-vue'
import noPermission from '@/views/error/NoPermission.vue'

const jwt = require('jsonwebtoken')

export default {
  components: {
    BContainer,
    BEmbed,
    noPermission,
  },
  data() {
    return {
      accessTransaction: false,
      dashboardUrl: null,
    }
  },
async mounted() {
  const permissionsObj = JSON.parse(sessionStorage.getItem('permissions')) || { permissions: [] }
  const permissions = (permissionsObj.permissions || []).map(p => +p)

  this.accessTransaction = permissions.includes(3)
  if (!this.accessTransaction) {
    return
  }

  const METABASE_SITE_URL = metaUrl()
  const METABASE_SECRET_KEY = accessKey()

  const payload = {
    resource: {
      dashboard: 577,
    },
    params: {
      ec: sessionStorage.getItem('veripagID')?.toString() || '',
    },
    exp: Math.round(Date.now() / 1000) + 10 * 60, 
  }

  const token = jwt.sign(payload, METABASE_SECRET_KEY)
  this.dashboardUrl = `${METABASE_SITE_URL}embed/dashboard/${token}#bordered=true&titled=true`
}

}
</script>
<style scoped lang="scss">
  @import "@core/scss/base/pages/page-reports.scss";
</style>
